import script from "./MetricCard.vue?vue&type=script&setup=true&lang=js"
export * from "./MetricCard.vue?vue&type=script&setup=true&lang=js"

import "./MetricCard.vue?vue&type=style&index=0&id=77b3ec2e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77b3ec2e"]])

export default __exports__